const TB = 'tb'
const COVID = 'covid'
const NODULE = 'nodule'
const MALIGNANCY_RISK = 'malignancy risk'
const MALIGNANCY_RISK_KEY = 'malignancy_risk'
const LNM = 'lung_nodule_malignancy'
const TAGS = ['nodule', 'tb', 'covid', 'abnormal']
const TB_FEEDBACK = 'tbFeedback'
const NODULE_FEEDBACK = 'noduleFeedback'
const MALIGNANCY_FEEDBACK = 'malignancyFeedback'
const ABNORMAL_FEEDBACK = 'abnormalFeedback'
const ABNORMAL = 'abnormal'
const PROCESSED = 'processed'
const PROCESSING = 'processing'
const XRAY_PENDING = 'xray_pending'
const INVALID_XRAY = 'invalid_xray'
const COVID_FEEDBACK = 'covidFeedback'
const SPUTUM_FEEDBACK = 'sputum_feedback'
const FEEDBACK = 'feedback'
const HIGH = 'high'
const MEDIUM = 'medium'
const LOW = 'low'
const NONE = 'none'
const YES = 'yes'
const NO = 'no'
const TUBERCULOSIS = 'tuberculosis'
const NAME = 'fullname'
const NONAME_NA = 'NA'
const POSITIVE = 'positive'
const NEGATIVE = 'negative'
const RADIOLOGIST = 'radiologist'
const HEALTHWORKER = 'healthworker'
const ADMIN = 'admin'
const AI = 'ai'
const AI_FEEDBACK = 'ai_feedback'
const COVID_FEEDBACK_VAL = 'covid_feedback_val'
const COVID_SCORE = 'covid_score'
const TB_FEEDBACK_VAL = 'tb_feedback_val'
const NODULE_FEEDBACK_VAL = 'nodule_feedback_val'
const RADIOLOGIST_FEEDBACK = 'rad_feedbacks' // 'feedback'
const AI_TB_FEEDBACK = 'aiTbFeedback'
const AI_NODULE_FEEDBACK = 'aiNoduleFeedback'
const AI_COVID_FEEDBACK = 'aiCovidFeedback'
const RADIOLOGIST_TB_FEEDBACK = 'radiologistTbFeedback'
const RADIOLOGIST_COVID_FEEDBACK = 'radiologistCovidFeedback'
const RADIOLOGIST_NODULE_FEEDBACK = 'radiologistNoduleFeedback'
const TB_LAMP_FEEDBACK = 'tbLampFeedback'
const GENEXPERT_FEEDBACK = 'genexpertFeedback'
const RTPCR_FEEDBACK = 'covid_rtpcr'
const TBLAMP_FEEDBACK = 'tblamp_feedback'
const SITENAME = 'sitename'
const PATIENT_ID = 'patientID'
const NATIONAL_ID = 'nationalID'
const CONTACT = 'contact'
const AGE = 'age'
const EMAIL = 'email'
const ZIPCODE = 'zipcode'
const ADDRESS = 'address'
const DESCRIPTION = 'description'
const GENDER = 'gender'
const SYMPTOMS = 'symptoms'
const RISKGROUPS = 'riskgroups'
const GENEXPERT = 'genexpert'
const TB_LAMP = 'tblamp'
const RTPCR = 'rtpcr'
const BC_DS = 'bc-ds'
const CD_DS = 'cd-ds'
const BC_RR = 'bc-rr'
const ADVISED = 'advised'
const NOT_ADVISED = 'not advised'
const NORMAL = 'normal'
const PRESUMPTIVE = 'presumptive'
const TO_BE_REVIEWED = 'To Be Reviewed'
const INDICATIVE = 'indicative'
const RT_PCR_FEEDBACK = 'rtpcrFeedback'
const MSK = 'msk'
const AI_STATES = {
  0: 'Pending',
  1: 'Presumptive',
  '-1': 'Negative',
  2: 'Review',
  '-2': 'Invalid X-Rays'
}

const RADIOLOGIST_STATES_TB = {
  0: 'Pending',
  1: 'Presumptive',
  '-1': 'Negative',
  '-2': 'Invalid X-Rays'
}
const RADIOLOGIST_STATES_COVID = {
  0: 'Pending',
  1: 'Indicative',
  '-1': 'Negative',
  '-2': 'Invalid X-Rays'
}
const RADIOLOGIST_STATES_NODULE = {
  0: 'Pending',
  1: 'Indicative',
  '-1': 'Negative',
  '-2': 'Invalid X-Rays'
}

const SPUTUM_STATES = {
  1: 'BC-DS',
  2: 'CD-DS',
  3: 'BC-RR',
  4: 'Normal'
}
const TB_LAMP_STATES = {
  1: 'Advised',
  '-1': 'Not Advised'
}
const ALL = 'all'

const RTPCR_STATES = {
  1: 'Positive',
  '-1': 'Negative'
}

const API_URL = 'API_URL'
const WS_API_URL = 'WS_API_URL'
const PROJECT_NAME = 'PROJECT_NAME'

// This is outdated
const TEST_TYPES = {
  tblamp_feedback: TB_LAMP_FEEDBACK,
  sputum_feedback: GENEXPERT_FEEDBACK,
  covid_rtpcr: RT_PCR_FEEDBACK
}

const MX_TOKEN = 'MX_TOKEN'

const WS_CLIENT_UPDATE = 'client.update'
const WS_CLIENT_CREATE = 'client.create'

const OTHER_SYMPTOMS_FIELD = 'other_symptoms'
const OTHER_RISK_GROUPS_FIELD = 'other_riskgroups'
const OTHER_SYMPTOMS_CHECKBOX_FIELD = 'other_symptoms_check'
const OTHER_RISK_GROUPS_CHECKBOX_FIELD = 'other_riskgroups_check'
const OTHER_CXR_ORD_REASON_FIELD = 'other_cxr_ordered'
const OTHER_CXR_ORD_REASON_CHECKBOX_FIELD = 'other_cxr_ordered_check'
const OTHER_DEFAULT = '$Other$'
const OTHER_OPTION_PLACEHOLDER = 'If other, please specify'
const CXR_ORDERED = 'cxr_ordered'
const GENEXPERT_LONG_FORMS = {
  BC: 'Bacteriologically Confirmed',
  CD: 'Clinically Diagnosed',
  RR: 'Rifampicin-resistant',
  DS: 'Drug-Sensitive'
}

const OCCUPATION = 'occupation'
const OTHER_OCCUPATION_FIELD = 'other_occupation'
const OTHER_OCCUPATION_CHECKBOX_FIELD = 'other_occupation_check'
const SMOKING_STATUS = 'smoking_status'
const CURRENT_SMOKER = 'current_smoker'
const SMOKER = 'smoker'
const NON_SMOKER = 'non-smoker'

const ACCESSION_NUMBER = 'AccessionNumber'

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]
const MONTHLY = 'monthly'

const X_RAY = 'X-Ray'

const TBR = 'toberead'
const MAX_FILE_UPLOAD_LIMIT = 10
const FILE_UPLOAD_DISCLAIMERS = [
  'A total of 10 files can be uploaded',
  'Files types of heic, png, jpeg, jpg, pdf can be uploaded',
  'Each file size must not exceed 5MB'
]
const MAX_FILE_SIZE = 5000000

const SAMPLE_COLLECTED_OPTIONS = [
  { label: 'Pending', value: '0' },
  { label: 'Yes', value: '1' },
  { label: 'No', value: '-1' }
]

const CT_COUNSELLING_OPTIONS = [
  { label: 'Done', value: '1' },
  { label: 'Pending', value: '0' },
  { label: 'Refused', value: '-1' }
]

const RAD_REPORTED = 'rad reported'

const UPDATED = 'updated'
const NOT_UPDATED = 'not_updated'

const CHILD_TAGS = ['consolidation', 'fibrosis', 'nodule']
const REPORT_TAGS = [
  'opacity',
  ...CHILD_TAGS,
  'cavity',
  'bluntedcp',
  'peffusion',
  'pneumothorax',
  'hilarlymphadenopathy',
  'cardiomegaly'
]
const SCAN_TYPE = 'scan_type'

export default {
  TB,
  COVID,
  NODULE,
  TAGS,
  TB_FEEDBACK,
  NODULE_FEEDBACK,
  PROCESSED,
  PROCESSING,
  XRAY_PENDING,
  INVALID_XRAY,
  COVID_FEEDBACK,
  SPUTUM_FEEDBACK,
  RTPCR_FEEDBACK,
  RTPCR_STATES,
  TBLAMP_FEEDBACK,
  HIGH,
  MEDIUM,
  LOW,
  NONE,
  YES,
  NO,
  TUBERCULOSIS,
  NAME,
  NONAME_NA,
  POSITIVE,
  NEGATIVE,
  RADIOLOGIST,
  HEALTHWORKER,
  ADMIN,
  AI,
  AI_TB_FEEDBACK,
  RADIOLOGIST_TB_FEEDBACK,
  TB_LAMP_FEEDBACK,
  GENEXPERT_FEEDBACK,
  AI_STATES,
  SITENAME,
  PATIENT_ID,
  NATIONAL_ID,
  CONTACT,
  AGE,
  GENDER,
  SYMPTOMS,
  RISKGROUPS,
  GENEXPERT,
  RTPCR,
  EMAIL,
  ZIPCODE,
  ADDRESS,
  DESCRIPTION,
  TB_LAMP,
  TB_LAMP_STATES,
  SPUTUM_STATES,
  BC_DS,
  CD_DS,
  BC_RR,
  ADVISED,
  NOT_ADVISED,
  NORMAL,
  ALL,
  PRESUMPTIVE,
  TO_BE_REVIEWED,
  INDICATIVE,
  AI_FEEDBACK,
  RADIOLOGIST_FEEDBACK,
  COVID_FEEDBACK_VAL,
  TB_FEEDBACK_VAL,
  AI_COVID_FEEDBACK,
  RADIOLOGIST_COVID_FEEDBACK,
  API_URL,
  WS_API_URL,
  COVID_SCORE,
  FEEDBACK,
  RADIOLOGIST_STATES_TB,
  RADIOLOGIST_STATES_COVID,
  PROJECT_NAME,
  TEST_TYPES,
  MX_TOKEN,
  WS_CLIENT_UPDATE,
  WS_CLIENT_CREATE,
  OTHER_SYMPTOMS_CHECKBOX_FIELD,
  OTHER_SYMPTOMS_FIELD,
  OTHER_RISK_GROUPS_FIELD,
  OTHER_RISK_GROUPS_CHECKBOX_FIELD,
  OTHER_CXR_ORD_REASON_FIELD,
  OTHER_CXR_ORD_REASON_CHECKBOX_FIELD,
  OTHER_DEFAULT,
  CXR_ORDERED,
  GENEXPERT_LONG_FORMS,
  OTHER_OPTION_PLACEHOLDER,
  MONTHS,
  ABNORMAL_FEEDBACK,
  ABNORMAL,
  ACCESSION_NUMBER,
  X_RAY,
  OCCUPATION,
  SMOKING_STATUS,
  OTHER_OCCUPATION_FIELD,
  OTHER_OCCUPATION_CHECKBOX_FIELD,
  CURRENT_SMOKER,
  SMOKER,
  TBR,
  MONTHLY,
  MALIGNANCY_FEEDBACK,
  LNM,
  MALIGNANCY_RISK,
  MALIGNANCY_RISK_KEY,
  MAX_FILE_UPLOAD_LIMIT,
  NON_SMOKER,
  FILE_UPLOAD_DISCLAIMERS,
  MAX_FILE_SIZE,
  NODULE_FEEDBACK_VAL,
  AI_NODULE_FEEDBACK,
  RADIOLOGIST_NODULE_FEEDBACK,
  RADIOLOGIST_STATES_NODULE,
  SAMPLE_COLLECTED_OPTIONS,
  CT_COUNSELLING_OPTIONS,
  RAD_REPORTED,
  UPDATED,
  NOT_UPDATED,
  CHILD_TAGS,
  REPORT_TAGS,
  MSK,
  SCAN_TYPE
}
